exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* latin-ext */\n@font-face {\n  font-family: 'Josefin Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Josefin Sans'), local('JosefinSans'), url(" + require("./fonts/josefin-ext.woff2") + ") format('woff2');\n  unicode-range: U+0100-024F, U+1E00-1EFF, U+20A0-20AB, U+20AD-20CF, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Josefin Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: local('Josefin Sans'), local('JosefinSans'), url(" + require("./fonts/josefin.woff2") + ") format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/css-loader?{"sourceMap":false,"importLoaders":1}!/root/anvel/~/postcss-loader?{"ident":"postcss"}!/root/anvel/angular/fonts.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../angular/fonts.css
// module chunks = 2